"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyActionSendMail = void 0;
const base_1 = require("./base");
const enums_1 = require("../../enums");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
exports.JourneyActionSendMail = (0, base_1.journeyAction)({
    action: enums_1.JourneyActionEnum.SendMail,
    settings_schema: (0, base_1.settingsValidationSchema)({
        mail_account_id: {
            type: 'number',
            required: true,
        },
        to: {
            type: 'array',
            items: {
                type: 'string',
                email: { tlds: { allow: false, }, },
            },
            required: true,
            min: 1,
        },
        subject: {
            type: 'string',
            required: true,
        },
        body: {
            type: 'string',
            required: true,
        },
    }),
    getPorts: (node) => {
        return Object.assign(Object.assign({}, base_1.journeyDefaultInputPort), { [constants_1.JOURNEY_ACTION_SEND_MAIL_OUTPUT]: (0, utils_1.journeyNodePortAddDefault)({
                id: constants_1.JOURNEY_ACTION_SEND_MAIL_OUTPUT,
                type: enums_1.JourneyPortDirectionEnum.Output,
                removable: false,
                required: false,
                index: 0,
                title: 'NEXT',
                color: null,
            }) });
    },
});
